<template>
    <div class="fui-i fui-field !mb-0" :class="props.class">
        <div class="fui-input-container relative">
            <span v-if="$slots.default" class="fui-icon">
                <slot></slot>
            </span>

            <label :for="id" :class="[ labelClass, isFocused ? 'scale-75 -translate-y-1 text-primary-500' : 'opacity-50 scale-100 translate-y-0' ]">{{ label }}&nbsp;<span v-if="required" class="fui-required">*</span></label>

            <input
                :id="id"
                v-model="model"
                :name="name"
                :type="type !== 'date' ? type : 'text'"
                :class="[ inputClass, isFocused ? 'pt-6 pb-2' : 'py-4' ]"
                :required="required"
                v-bind="$attrs"
                @focus="focus"
                @blur="blur"
            >
        </div>
    </div>
</template>

<script setup>
import { computed, shallowRef } from 'vue';

defineOptions({
    inheritAttrs: false,
});

const {
    name, type, required, label, labelClass, inputClass,
    ...props
} = defineProps({
    name: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        default: 'text',
    },
    label: {
        type: String,
        required: true,
    },
    required: {
        type: Boolean,
        default: false,
    },
    class: {
        type: String,
        default: '',
    },
    labelClass: {
        type: String,
        default: 'fui-label absolute inset-y-0 left-4 flex items-center origin-top-left !transition-all !duration-100 !ease-in',
    },
    inputClass: {
        type: String,
        default: 'fui-input',
    },
});

const id = computed(() => {
    return name.replaceAll('[', '-').replaceAll(']', '');
});

const model = defineModel({
    type: String,
    default: '',
});

const focused = shallowRef(false);

const isFocused = computed(() => {
    return model.value || focused.value;
});

defineEmits(['focus', 'blur']);

function focus() {
    focused.value = true;
    $emit('focus');
}

function blur() {
    focused.value = false;
    $emit('blur');
}
</script>
